import { Flex } from '@chakra-ui/react';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { FAIcon } from 'components/FAIcon';
import { useAuth, useCheckSettings } from 'features/auth';
import { FEATURE_FLAG } from 'types/featureFlag';

import { TopNavbarDropdownDivider } from './TopNavbarDropdownDivider';
import { TopNavbarDropdownItem } from './TopNavbarDropdownItem';
import { TopNavbarDropdownItemButton } from './TopNavbarDropdownItemButton';
import { TopNavbarDropdownItemLink } from './TopNavbarDropdownItemLink';
import { UserDropdown } from './UserDropdown';

const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL;
const ADMIN_PORTAL_URL = process.env.REACT_APP_ADMIN_PORTAL_URL || '';

interface UserProps {
  userName: string;
  customerName: string;
  isCustomerClient?: boolean;
  isSuperAdmin?: boolean;
  isAdmin?: boolean;
}
export const TopNavbarUser = ({
  userName,
  customerName,
  isCustomerClient,
  isSuperAdmin,
  isAdmin,
}: UserProps) => {
  const { logout } = useAuth();
  const [hasSettings] = useCheckSettings();
  const isAdminUser = useMemo(() => isSuperAdmin || isAdmin, [isSuperAdmin, isAdmin]);
  const isAdminPortalEnabled = hasSettings(FEATURE_FLAG.ENABLE_ADMIN_PORTAL);

  return (
    <UserDropdown name={userName} tenant={customerName}>
      {!isCustomerClient && (
        <TopNavbarDropdownItem as={Link} to="/profile" variant="default">
          Edit Profile
        </TopNavbarDropdownItem>
      )}
      <TopNavbarDropdownItemLink href={`${REDIRECT_URL}users/edit_password`}>
        Change Password
      </TopNavbarDropdownItemLink>
      <TopNavbarDropdownDivider />
      <TopNavbarDropdownItemLink href={`${REDIRECT_URL}two_factor_authentication`}>
        2FA Authentication
      </TopNavbarDropdownItemLink>
      {isAdminUser && isAdminPortalEnabled && ADMIN_PORTAL_URL && (
        <TopNavbarDropdownItemLink
          href={ADMIN_PORTAL_URL}
          target="_blank"
          data-tenant={customerName}
          rel="noopener"
        >
          Admin Portal
        </TopNavbarDropdownItemLink>
      )}
      <TopNavbarDropdownDivider />
      <TopNavbarDropdownItemButton
        onClick={() => {
          logout();
        }}
      >
        <Flex alignItems="center" justifyContent="space-between" w="full">
          Logout
          <FAIcon icon="sign-out-alt" variant="solid" />
        </Flex>
      </TopNavbarDropdownItemButton>
    </UserDropdown>
  );
};
